import {loadSingleStepDefault, loadSingleStepMenu} from "./ProductHelper";
import {generateProductConfigSteps, resetConfigurationStep} from "../libraries/utils";
import {SET_BASKET_STATE_ON_ONE_STEP_FLOW_WITH_FOUR_COLUMNS} from "../store/mutation-types";

export const redirectToProductConfiguration = (self, {item, baseProductId, upsellFlow, dialogCategory}) => {
	const isMenu = item.product.departmentId === 2;
	const shouldRedirectToSingleStep = isMenu
		? loadSingleStepMenu(item.product, self.featureToggles, self.isKioskChannel)
		: loadSingleStepDefault(item.product, self.featureToggles, self.isKioskChannel);
	if (shouldRedirectToSingleStep) {
		const productCategory = self.$store.getters.productCatalog.getCategoryFromProduct(item.product);
		if(self.featureToggles.enableThreeStepFullscreenCheckout) {
			self.$router.push(`/category/${productCategory.extId}`);
			self.$store.commit(SET_BASKET_STATE_ON_ONE_STEP_FLOW_WITH_FOUR_COLUMNS, false);
		}
		setTimeout(() => {
			self.$router.push({
				name: item.product.departmentId === 2 ? "productDetailsConfigurationSinglePage" : "productDetailsConfigurationSinglePageSimpleItem",
				params: {
					item: item,
					productId: item.product.id,
					baseProductId: baseProductId || (item && item.product.id),
					productSelectionId: item.productSelections[item.productSelections.length - 1].productSelectionId,
					upsellFlow,
					dialogCategory
				}
			});
		});
	} else {
		if(self.isKioskChannel && self.featureToggles.enableThreeStepFullscreenCheckout) {
			// This is only to handle navigation from upsell click on full basket route
			const productCategory = self.$store.getters.productCatalog.getCategoryFromProduct(item.product);
			self.$router.push(`/category/${productCategory.extId}`);
		}
		setTimeout(() => {
			goToConfigurationStep(self, {
				item,
				baseProductId: baseProductId || (item && item.product.id),
				upsellFlow,
				dialogCategory
			});
		}, 100);
	}
};

export const goToConfigurationStep = (self, {item, baseProductId, upsellFlow, dialogCategory}) => {
	resetConfigurationStep(self);
	const configurationSteps = generateProductConfigSteps(item);
	if(configurationSteps.length > 0) {
		self.$router.push({
			name: "productDetailsConfiguration",
			params: {
				item: item,
				type: configurationSteps[0].toLowerCase(),
				productId: item.product.id,
				baseProductId,
				dialogCategory,
				productSelectionId: item.productSelections[item.productSelections.length - 1].productSelectionId,
				upsellFlow: upsellFlow
			}
		});
	}
};
